import { http, HttpResponse } from 'msw';

import { ParametersResponse } from 'shared/openapi/models/parameters-response';

export default http.get('/api/WEB/admin/parameters', () =>
  HttpResponse.json<ParametersResponse>({
    parameters: [],
    page: { currentPage: 0, totalElements: 0, totalPages: 0 },
  })
);
